import { render, staticRenderFns } from "./personalInformation.vue?vue&type=template&id=d21a3510&scoped=true"
import script from "./personalInformation.vue?vue&type=script&lang=js"
export * from "./personalInformation.vue?vue&type=script&lang=js"
import style0 from "./personalInformation.vue?vue&type=style&index=0&id=d21a3510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21a3510",
  null
  
)

export default component.exports